package gr.tech.pdfgenerator.models

import gr.tech.pdfgenerator.sections.formatPercentage
import kotlinx.serialization.Serializable

@Serializable
data class TierThreeDTO(

    // Address Overwrite & Values
    var addressOverwriteCheck: Boolean = false,
    var addressOverwrite: String = "",
    var stateOverwrite: String = "",
    var cityOverwrite: String = "",
    var zipOverwrite: String = "",

    // Lighting Proposal Overwrite & Values
    var proposalShowInPDF: Boolean = false,
    var proposalOverwriteCheck: Boolean = false,
    var rebatesOverwrite: Long = 0,
    var projectCostOverwrite: Long = 0,
    var totalAnnualSavingsOverwrite: Long = 0,
    var cummCashFlowListOverwrite: Long = 0,
    var annualizedROIOverwrite: Double = 0.0,
    var simplePaybackOverwrite: Double = 0.0,

    var grRepName: String = "",
    var grRepTitle: String = "",

    var equipmentType: String = "",
    var lightingPercentage: Double = 0.0,
    var dehumidifierPercentage: Double = 0.0,
    var heatCurtainPercentage: Double = 0.0,
    var hvacPercentage: Double = 0.0,

    var equipmentList: List<TierThreeEquipmentDTO> = mutableListOf()
) {
    override fun toString(): String {
        return """
            |TierThreeDTO(
            |  GR Rep Name          : $grRepName
            |  GR Rep Title         : $grRepTitle
            |  
            |  Equipment Type       : $equipmentType
            |  Lighting (%)         : ${formatPercentage(lightingPercentage)}
            |  Dehumidifier (%)     : ${formatPercentage(dehumidifierPercentage)}
            |  Heat Curtain (%)     : ${formatPercentage(heatCurtainPercentage)}
            |  HVAC (%)             : ${formatPercentage(hvacPercentage)}
            |  Equipment        : ${if (equipmentList.isEmpty()) "None" else ""}
            |${equipmentList.joinToString("\n") { it.toString().prependIndent("  |    ") }}
            |)
            |)
        """.trimMargin()
    }
}

@Serializable
data class TierThreeEquipmentDTO(
    var phase: String = "",
    var equipment: String = "",
    var notes: String = "",
) {
    override fun toString(): String {
        return """
            |- Phase        : $phase
            |  Equipment    : $equipment
            |  Notes        : $notes
        """.trimMargin()
    }
}